import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Donate from "@/pages/Donate";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Volunteer from "@/pages/Volunteer";
import { EventDetail } from "@/pages/Events";
import EventsPageRoute from "@/pages/EventsPage";
import BuyShirt, { BuyShirtThankYou } from "@/pages/BuyShirt";
import RegisterRun, { RegisterRunThankYou } from "@/pages/RegisterRun";
import Raffle, { RaffleThankYou } from "@/pages/Raffle";
import RafflePoster from "@/pages/RafflePoster";
import { RaffleGate } from "@/components/RaffleGate";
import { Mission, About, Stories, GetInvolved, Partnership, Legal, Collaborators } from "@/pages/StaticPages";
import ImpactPageRoute from "@/pages/ImpactPage";
import Join from "@/pages/Join";
import KbHallenGone from "@/pages/KbHallenGone";
import GeneralAssembly from "@/pages/GeneralAssembly";
import { AdminLogin, AdminDashboard } from "@/pages/Admin";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/raffle-poster" element={<RaffleGate><RafflePoster /></RaffleGate>} />
            <Route path="*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/mission" element={<Mission />} />
                  <Route path="/events" element={<EventsPageRoute />} />
                  {/* Social Run registration is closed — the run is over.
                      Historical register URLs permanently redirect to the recap.
                      Historical records stay intact in the DB. */}
                  <Route path="/events/social-run-for-spain/register" element={<Navigate to="/events/social-run-for-spain" replace />} />
                  <Route path="/events/social-run-for-spain/register/thank-you" element={<RegisterRunThankYou />} />
                  <Route path="/events/:slug" element={<EventDetail />} />
                  <Route path="/register" element={<Navigate to="/events/social-run-for-spain" replace />} />
                  <Route path="/register/thank-you" element={<Navigate to="/events/social-run-for-spain/register/thank-you" replace />} />
                  <Route path="/events/:slug/register" element={<Navigate to="/events/social-run-for-spain" replace />} />
                  <Route path="/donate" element={<Donate />} />
                  <Route path="/thank-you" element={<PaymentSuccess />} />
                  <Route path="/registration-confirmed" element={<PaymentSuccess />} />
                  <Route path="/shirts" element={<BuyShirt />} />
                  <Route path="/shirts/thank-you" element={<BuyShirtThankYou />} />
                  <Route path="/raffle" element={<Raffle />} />
                  <Route path="/raffle/thank-you" element={<RaffleThankYou />} />
                  <Route path="/stories" element={<Stories />} />
                  <Route path="/impact" element={<ImpactPageRoute />} />
                  <Route path="/get-involved" element={<GetInvolved />} />
                  <Route path="/join" element={<Join />} />
                  {/* Replacement event — General Assembly & Live Raffle Draw (25 Oct 2026). */}
                  <Route path="/events/general-assembly-raffle-draw-2026" element={<GeneralAssembly />} />
                  {/* KB Hallen is permanently retired. The route serves a
                      410 Gone page — NO redirect to any other event. The
                      actual HTTP 410 status is emitted by the dev-server
                      middleware (craco.config.js); production hosting must
                      mirror the same rule at its own layer. */}
                  <Route path="/events/kb-hallen-2026" element={<KbHallenGone />} />
                  <Route path="/events/kb-hallen-2026/*" element={<KbHallenGone />} />
                  <Route path="/collaborators" element={<Collaborators />} />
                  <Route path="/volunteer" element={<Volunteer />} />
                  <Route path="/partnership" element={<Partnership />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/legal/:doc" element={<Legal />} />
                </Routes>
              </Layout>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </LanguageProvider>
    </div>
  );
}
export default App;
